import { createFileRoute, notFound } from "@tanstack/react-router";

import { maintenanceTagsQueries } from "@/api/resources/maintenanceTags/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import { MaintenanceTagsPage } from "@/components/MaintenanceTag/MaintenanceTagsPage";
import i18n from "@/providers/i18n";
import { Icon } from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/tags/maintenance-tags/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.tags-maintenance-tags"),
        icon: <Icon.MAINTENANCE_TAGS />,
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
    await context.queryClient.ensureQueryData(maintenanceTagsQueries.listAll());
  },
  component: MaintenanceTagsPage,
});
